import axios from 'axios'

export default {
  getAds(params) {
    return axios.get('/publicidade', {
      params
    })
  },
  editAds(id, payload) {
    //console.log('editAds :: '+JSON.stringify(payload, null, 2))
    return axios.patch(`/publicidade/${id}`, payload)
  },
  saveAds(payload) {
    //console.log('API: '+JSON.stringify(payload, null, 2))
    return axios.post('/publicidade/', payload)
  },

  getUploadUrl(payload) {
    return axios.post('/s3', payload)
  }

}
